module.exports = __webpack_public_path__ + "static/media/29ADMSPC30.c96bd369.jpg";